import React from 'react';
import { Award } from '../../../Recommendations/components/Award/Award';
export const Bonus = ({ bonus }) => {
    if (!bonus)
        return null;
    return React.createElement(Award, { value: bonus, currency: "USD", text: " sample credit" });
};
